export enum IRoleEnum {
  SUPER_ADMIN = "admin",
  STORE = "store",
  STORE_EMPLOYEE = "store_employee",
  UNKNOWN = "unknown",
}
export enum IUserTableTabsEnum {
  Active = "active",
  Deactive = "deactive",
}

export enum IGendersEnum {
  Male = "male",
  Female = "female",
}

export enum IFileSizeUnitEnum {
  BYTES = "Bytes",
  KB = "Kb",
  MB = "Mb",
  GB = "Gb",
  TB = "Tb",
  // "PB",
  // "EB",
  // "ZB",
  // "YB",
}

export enum IUniversityKindEnum {
  One = "one",
  Two = "two",
  Medical = "med",
}

export enum ITransactionTypeEnum {
  Buy = "buy",
  Sale = "sale",
  Return = "return",
  WarehouseEntry = "warehouseEntry",
  WarehouseExit = "warehouseExit",
  ScrapEntry = "scrapEntry",
}
